import React, { useEffect, useState } from 'react';
import { Marker } from '@react-google-maps/api';
import './CircleMarkerImage.css';

const CircleMarker = ({
  position,
  image,
  onClick,
  size = 40,
  clusterer,
  highlighted = false,
}) => {
  const [circularIcon, setCircularIcon] = useState(null);

  useEffect(() => {
    // Create a circular marker icon using HTML canvas
    const createCircularIcon = () => {
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');

      // Create a circular clipping path
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2 - 2, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.clip();

      // Create image element
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Handle CORS

      // img.onload = () => {
      //   // Draw the image within our clipping region
      //   ctx.drawImage(img, 0, 0, size, size);

      //   // Draw a white border around the circle
      //   ctx.strokeStyle = '#2F80ED';
      //   ctx.lineWidth = 4;
      //   ctx.beginPath();
      //   ctx.arc(size / 2, size / 2, size / 2 - 2, 0, Math.PI * 2);
      //   ctx.stroke();

      //   // Create the icon with our canvas
      //   const iconUrl = canvas.toDataURL();
      //   setCircularIcon({
      //     url: iconUrl,
      //     scaledSize: new window.google.maps.Size(size, size),
      //     origin: new window.google.maps.Point(0, 0),
      //     anchor: new window.google.maps.Point(size / 2, size / 2)
      //   });
      // };

      img.onerror = () => {
        // Fallback to non-circular marker if image fails to load
        console.error('Failed to load image for circular marker:', image);
        setCircularIcon({
          url: image,
          scaledSize: new window.google.maps.Size(size, size),
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point(size / 2, size / 2)
        });
      };

      // Set the source to start loading
      img.src = image;
    };

    createCircularIcon();

    // Clean up function
    return () => {
      if (circularIcon && circularIcon.url.startsWith('data:')) {
        // Clean up any blob URLs if we used them
        // No need to revoke data URLs
      }
    };
  }, [image, size]);

  // Use the standard marker with our circular icon, or a fallback while loading
  const fallbackIcon = {
    url: image,
    scaledSize: new window.google.maps.Size(size, size),
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(size / 2, size / 2)
  };

  return (
    <Marker
      position={position}
      onClick={onClick}
      icon={circularIcon || fallbackIcon}
      zIndex={highlighted ? 1000 : 1}
      clusterer={clusterer}
    />
  );
};

export default CircleMarker;
